import { isolateComponent } from '@zapier/style-encapsulation';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { Price } from '@zapier/currency';
import { Fragment } from 'react';
import { buildUpgradeUrl, getShouldRenderSunsetCopy } from './utils';
export const shouldRender = (data) => {
    const { currentAccount } = data;
    const { isTrialing, trialEndDate } = currentAccount;
    return (!isTrialing &&
        !!trialEndDate &&
        currentAccount.plan.amount === 0 &&
        daysFromNow(trialEndDate) <= 14);
};
export const Component = function ProfessionalTrialEnded(props) {
    var _a, _b;
    const { data, currency } = props;
    const { currentAccount } = data;
    const upgradeUrl = buildUpgradeUrl({
        currentPlanName: currentAccount.plan.name,
        upgradePlanName: (_a = data.nextPlan) === null || _a === void 0 ? void 0 : _a.name,
        interval: currentAccount.plan.interval,
    });
    const nextPlanAmount = (((_b = data.nextPlan) === null || _b === void 0 ? void 0 : _b.amount) || 0) / 12;
    const pricingText = nextPlanAmount > 0 && (isolateComponent("span", null,
        "for as low as ",
        isolateComponent(Price, { currency: currency }, nextPlanAmount),
        "/month"));
    const onUpgrade = () => {
        props.trackEvent('Trial: clicked banner', {
            in_trial: false,
        });
    };
    const shouldRenderCopy = getShouldRenderSunsetCopy(currentAccount.campaignOffers);
    const offer = shouldRenderCopy && currentAccount.campaignOffers[0];
    return (isolateComponent(Alert, { layout: props.layout, title: "Your Professional trial has ended", type: "info" }, offer ? (isolateComponent(Fragment, null,
        isolateComponent(Link, { href: "/app/billing/plans" }, "Upgrade now"),
        "\u00A0to keep using multi-step Zaps, filters, premium apps, and more. Plus get a free year of Zapier when you upgrade by November 14th, 2022.")) : (isolateComponent(Fragment, null,
        isolateComponent(Link, { href: upgradeUrl, onClick: onUpgrade }, "Upgrade"),
        "\u00A0",
        pricingText,
        " to keep using multi-step Zaps, filters, premium apps, and more"))));
};
//# sourceMappingURL=ProfessionalTrialEnded.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
